import React from "react";
import { useSlc, RootState } from "app/store";
import { WrapperUserWishes } from "app/wrappers";
import RedirectTo from "components/RedirectTo/RedirectTo";

export const UserWishes = () => {
  const isAuth = useSlc((state: RootState) => state.user.isAuth);

  if (isAuth) return <WrapperUserWishes />;
  return <RedirectTo path="/sign-in" />;
};
